// methods here build URLs for site pages

import utilityService from './utilityService.js'
import deepCopyService from './deepCopyService.js'

export default {
    mixins: [utilityService, deepCopyService],
    methods: {
        remove2dRowMajorGridRow(gridArray, rowNum) {
            // console.log('in remove2dRowMajorGridRow, gridArray: ' + JSON.stringify(gridArray) + ', rowNum: ' + rowNum)
            gridArray.splice(rowNum, 1)
        },

        insert2dRowMajorGridRow(gridArray, insertAfterRowNum) {
            // console.log('in insert2dRowMajorGridRow, before gridArray: ' + JSON.stringify(gridArray) + ', insertAfterRowNum: ' + insertAfterRowNum)
            let columnsCount = gridArray[0].length
            let newRow = new Array(columnsCount)
            console.log('columnsCount: ' + columnsCount + ', newRow: ' + JSON.stringify(newRow) + 'insertAfterRowNum: ' + insertAfterRowNum)
            gridArray.splice(insertAfterRowNum, 0, newRow)
            console.log('in insert2dRowMajorGridRow, after gridArray: ' + JSON.stringify(gridArray) + ', insertAfterRowNum: ' + insertAfterRowNum)
        },

        remove2dRowMajorGridColumn(gridArray, colNum) {
            // console.log('in remove2dRowMajorGridColumn, gridArray: ' + JSON.stringify(gridArray) + ', colNum: ' + colNum)
            for (let row=0; row < gridArray.length; row++) {
                gridArray[row].splice(colNum, 1)
            }
        },

        insert2dRowMajorGridColumn(gridArray, insertAfterColNum) {
            // console.log('in insert2dRowMajorGridColumn, gridArray: ' + JSON.stringify(gridArray) + ', insertAfterColNum: ' + insertAfterColNum)
            for (let row=0; row < gridArray.length; row++) {
                gridArray[row].splice(insertAfterColNum, 0, null)
            }
        },

        remove1dGridColumn(gridArray, colNum) {
            // console.log('in remove1dGridColumn, gridArray: ' + JSON.stringify(gridArray) + ', colNum: ' + colNum)
            gridArray.splice(colNum, 1)
        },

        insert1dGridColumn(gridArray, insertAfterColNum) {
            // console.log('in insert1dGridColumn, gridArray: ' + JSON.stringify(gridArray) + ', insertAfterColNum: ' + insertAfterColNum)
            gridArray.splice(insertAfterColNum, 0, {})
        },

        getDisplayGridIndex(original, isReversed, totalSize) {
            return !isReversed ? original : totalSize - 1 - original
        },

        buildEmpty2dRowMajorGrid(rowsCount, columnsCount) {
            let grid = []
            for (let row = 0; row < rowsCount; row++) {
                let rowArray = []
                for (let col=0; col < columnsCount; col++) {
                    rowArray.push(false)
                }
                grid.push(rowArray)
            }
            return grid
        },

        buildPointThreaded2dRowMajorGrid(rowsCount, columnsCount, rowsRepresentShafts) {
            let grid = this.buildEmpty2dRowMajorGrid(rowsCount, columnsCount)
            if (!rowsRepresentShafts) {
                grid = this.rotate2dArray(grid)
            }
            let rowsInGrid = grid.length
            let colsInGrid = grid[0].length
            let direction = 1
            let row = 0
            for (let col = 0; col < colsInGrid; col++) {
                // console.log('row: ' + row + ', col: ' + col)
                grid[row][col] = true
                row += direction
                if (row === rowsInGrid) {
                    row = rowsInGrid - 2
                    direction = -1
                }
                else if (row === -1) {
                    row = 1
                    direction = 1
                }
            }
            if (!rowsRepresentShafts) {
                grid = this.rotate2dArray(grid)
            }
            return grid
        },

        buildStraightThreaded2dRowMajorGrid(rowsCount, columnsCount, rowsRepresentShafts) {
            let grid = this.buildEmpty2dRowMajorGrid(rowsCount, columnsCount)
            if (!rowsRepresentShafts) {
                grid = this.rotate2dArray(grid)
            }
            let rowsInGrid = grid.length
            let colsInGrid = grid[0].length
            let row = 0
            for (let col = 0; col < colsInGrid; col++) {
                grid[row][col] = true
                row++
                if (row === rowsInGrid) {
                    row = 0
                }
            }
            if (!rowsRepresentShafts) {
                grid = this.rotate2dArray(grid)
            }
            return grid
        },

        set2dRowMajorGridPointWithBoundsChecking(row, col, val, grid, clearEntireGridRow, clearEntireGridColumn) {
            // console.log('set2d: row: ' + row + ', col: ' + col)
            if (clearEntireGridRow) {
                this.clearEntireRow(row, grid)
            }
            if (clearEntireGridColumn) {
                this.clearEntireColumn(col, grid)
            }
            if (row >= 0 && col >= 0) {
                let rowsCount = grid.length
                let colsCount = grid[0].length
                if (row < rowsCount && col < colsCount) {
                    grid[row][col] = val
                }
            }
        },

        toggle2dRowMajorGridPointWithBoundsChecking(row, col, grid) {
            // console.log('toggle2d: row: ' + row + ', col: ' + col)
            if (row >= 0 && col >= 0) {
                let rowsCount = grid.length
                let colsCount = grid[0].length
                if (row < rowsCount && col < colsCount) {
                    grid[row][col] = !grid[row][col]
                }
            }
        },

        isEmpty2dRow(rowArr) {
            for (let c = 0; c < rowArr.length; c++) {
                if (rowArr[c]) {
                    return false
                }
            }
            return true
        },

        remove2dRowMajorEmptyRowsAndColumns(arr) {
            let nonEmptyRowsArray = []
            for (let r=0; r < arr.length; r++) {
                if (!this.isEmpty2dRow(arr[r])) {
                    nonEmptyRowsArray.push(this.deepCopy(arr[r]))
                }
            }
            if (nonEmptyRowsArray.length === 0) {
                return []
            }

            let nonEmptyColsArray = []
            let rotatedArray = this.rotate2dArray(nonEmptyRowsArray)
            for (let r=0; r < rotatedArray.length; r++) {
                if (!this.isEmpty2dRow(rotatedArray[r])) {
                    nonEmptyColsArray.push(this.deepCopy(rotatedArray[r]))
                }
            }
            if (nonEmptyColsArray.length === 0) {
                return []
            }

            return this.rotate2dArray(nonEmptyColsArray)
        },

        preventDefaultTouch(e) {
            if (e.cancelable) {
                e.preventDefault()
            }
        },

        disableTouchScroll(domElement) {
            domElement.addEventListener('touchmove', this.preventDefaultTouch, { passive: false })
        },

        enableTouchScroll(domElement) {
            domElement.removeEventListener('touchmove', this.preventDefaultTouch)
        },

        clearEntireColumn(colNum, gridArrayToClear) {
            // console.log('clearEntireColumn: ' + colNum)
            let rowsCount = gridArrayToClear.length
            for (let rowNum=0; rowNum < rowsCount; rowNum++) {
                gridArrayToClear[rowNum][colNum] = false
            }
        },

        clearEntireRow(rowNum, gridArrayToClear) {
            // console.log('clearEntireRow: ' + rowNum)
            let columnsCount = gridArrayToClear[0].length
            for (let colNum=0; colNum < columnsCount; colNum++) {
                gridArrayToClear[rowNum][colNum] = false
            }
        },

        rowIsEmpty(rowNum, gridArray) {
            let columnsCount = gridArray[0].length
            for (let colNum=0; colNum < columnsCount; colNum++) {
                if (gridArray[rowNum][colNum]) {
                    return false
                }
            }
            return true
        },

        columnIsEmpty(colNum, gridArray) {
            let rowsCount = gridArray.length
            for (let rowNum=0; rowNum < rowsCount; rowNum++) {
                if (gridArray[rowNum][colNum]) {
                    return false
                }
            }
            return true
        },

        determinePointsOnLine(startRow, startCol, endRow, endCol) {
            let rowIncrement = 0
            let columnIncrement = 0

            console.log('startRow: ' + startRow + ', startCol: ' + startCol)
            console.log('endRow: ' + endRow + ', endCol: ' + endCol)

            let lineCellsList = []

            if (startRow === endRow) {
                return this.horizontalLinePointsArray(startRow, startCol, endCol)
            }

            if (startCol === endCol) {
                return this.verticalLinePointsArray(startCol, startRow, endRow)
            }

            rowIncrement = startRow > endRow ? -1 : 1
            columnIncrement = startCol > endCol ? -1 : 1

            // console.log('rowIncrement: ' + rowIncrement + ', columnIncrement: ' + columnIncrement)

            let row = parseInt(startRow)
            let col = parseInt(startCol)

            // console.log('row increment: ' + rowIncrement + ', columnIncrement: ' + columnIncrement)

            if (this.rowsRepresentShafts) {
                while (col !== endCol) {
                    // console.log('row: ' + row + ', col: ' + col)
                    this.addPointToLineIfDoesNotExist(lineCellsList, row, col)
                    // console.log('before row: ' + row)
                    row += rowIncrement
                    // console.log('after row: ' + row)
                    col += columnIncrement
                    if (startRow < endRow && row > endRow) {
                        row = startRow
                        // console.log('corrected row a: ' + row)
                    }
                    else if (startRow > endRow && row < endRow) {
                        row = startRow
                        // console.log('corrected row b: ' + row)
                    }
                }
                this.addPointToLineIfDoesNotExist(lineCellsList, row, col)
            }

            else {
                while (row !== endRow) {
                    // console.log('col: ' + col + ', row: ' + row)
                    this.addPointToLineIfDoesNotExist(lineCellsList, row, col)
                    // console.log('before col: ' + col)
                    col += columnIncrement
                    // console.log('after col: ' + col)
                    row += rowIncrement
                    if (startCol < endCol && col > endCol) {
                        col = startCol
                        console.log('corrected col a: ' + col)
                    }
                    else if (startCol > endCol && col < endCol) {
                        col = startCol
                        console.log('corrected col b: ' + col)
                    }
                }
                this.addPointToLineIfDoesNotExist(lineCellsList, row, col)
            }

            return lineCellsList
        },

        numToStringWithoutScientificNotation(num) {
            let s = num.toString()
            if (s.indexOf('e-') > -1) {
                return '0'
            }
            return s
        },

        addPointToLineIfDoesNotExist(list, row, col) {
            for (let c=0; c < list.length; c++) {
                let point = list[c]
                if (point.row === row && point.col === col) {
                    return
                }
            }
            list.push({ row: row, col: col })
        },

        verticalLinePointsArray(col, startRow, endRow) {
            let lineCellsList = []
            let rowIncrement = (startRow < endRow) ? 1 : -1
            let r = startRow
            while (r !== endRow) {
                lineCellsList.push({ row: r, col: col })
                r += rowIncrement
            }
            lineCellsList.push({ row: r, col: col })
            return lineCellsList
        },

        horizontalLinePointsArray(row, startCol, endCol) {
            let lineCellsList = []
            let colIncrement = (startCol < endCol) ? 1 : -1
            let c = startCol
            while (c !== endCol) {
                lineCellsList.push({ row: row, col: c })
                c += colIncrement
            }
            lineCellsList.push({ row: row, col: c })
            return lineCellsList
        }
    }
}
